Helpers.prototype.test = (text) => console.log(text);
